import { AxiosError, AxiosResponse } from 'axios';

import { apiWrapper, axiosApi, errorNotificationWith } from 'utils/api';
import { UserModel } from 'core/models';
import { RawUser, User } from 'core/models/userModel';
import { logoutUser } from 'pages/signIn';
import { setUser, setSite, setSensorType } from 'reducers/session';
import { store } from 'store';
import getTimeZoneDict from 'core/service/timeZone.service';
import { changeUserLanguageTmp } from 'i18n';
import { ruleTrans } from 'core/config/config';
import { CGMSensorType, sensorTypeSel } from 'constant/common';

export const getCurrentUser = async (
  notQueGetTimeZone?: boolean,
): Promise<AxiosResponse<User> | any> => {
  const success = async (): Promise<any> => {
    const response = await axiosApi().get<RawUser>(`/currentUserInfo`);
    if (response) {
      response.data.roles = response?.data?.roles?.map((item: string) => {
        if (item === 'super_admin' && !response?.data?.tenant?.isSuper) {
          return {
            name: ruleTrans.tenant_admin,
          };
        }
        return {
          name: ruleTrans[item],
        };
      });
      store.dispatch(
        setUser({
          user: new UserModel(response.data),
        }),
      );
      let sensorTypeList = sensorTypeSel;
      if (response.data.tenant?.cgmStatus) {
        sensorTypeList = [...sensorTypeList, CGMSensorType];
      }
      store.dispatch(
        setSensorType({
          sensorTypeList,
        }),
      );
      if (response?.data?.language != null) {
        changeUserLanguageTmp(response.data.language);
      }
      if (notQueGetTimeZone == null || !notQueGetTimeZone) {
        getTimeZoneDict();
      }
    }
    return response;
  };
  const error = (e: any): AxiosResponse<User> | void => {
    if (e.response?.status === 404) {
      logoutUser();
    } else if (e.response?.status === 401) {
      errorNotificationWith({ message: e?.response?.data?.message });
      console.log('e?.response?.data', e?.response?.data);
      if (e?.response?.data?.reason === 'Need_Mfa_Verify') {
        window.location.href = `/totpConfirm`;
      } else {
        window.location.href = `/error?message=${e?.response?.data?.message}&code=401`;
      }
    }
    return e.response;
  };

  return apiWrapper<User>({
    success,
    error,
  });
};

export const initSite = async (tenantId?: string) => {
  try {
    const response = await axiosApi().get(`/sites/all`, {
      params: { tenantId },
    });
    if (response) {
      store.dispatch(
        setSite({
          siteList: response?.data?.data || [],
        }),
      );
    }
  } catch (error) {
    console.error(error);
  }
};

export default getCurrentUser;
